import {
    convertCurrencyFormatPositiveNegative,
    RaikoBaseCardContainer, RaikoFlexAlignStart,
    RaikoGridThreeColumn,
    RaikoLabel,
    RaikoLabelType
} from "@moeindal/base-raiko-panel-components";
import "./MealsItem.scss"
import {css} from "@emotion/css";
import icBreakfast from "../../../../assets/svg/ic_milk.svg";
import icLunch from "../../../../assets/svg/ic_chiken.svg";
import icDinner from "../../../../assets/svg/ic_pizza.svg";
import {Skeleton} from "@mui/material";
import * as React from "react";

function getSkeleton() {
    return <Skeleton
        variant="rectangular"
        className={css`
            padding: 8px;
            min-width: 120px;`}
    />;
}

export default function MealsItem({breakfast, lunch, dinner, loading}) {


    return (
        <RaikoGridThreeColumn>
            <RaikoBaseCardContainer className={"baseMealsItemContainer"}>
                <RaikoFlexAlignStart className={css`align-items: center;
                    gap: 1rem;`}>
                    <div className={"mealsItemIconContainer"}>
                        <img src={icBreakfast} alt="breakfast"/>
                    </div>
                    <RaikoLabel
                        text={"صبحــانه"}
                        raikoLabelType={RaikoLabelType.TITLE}
                        className={css`
                            flex-grow: 1;
                        `}
                    />
                    {
                        loading ?
                            getSkeleton() :

                            <RaikoLabel
                                text={convertCurrencyFormatPositiveNegative(breakfast)}
                                raikoLabelType={RaikoLabelType.TITLE}
                                className={css`
                                    font-size: 20px;
                                    text-align: left;`}
                            />
                    }
                </RaikoFlexAlignStart>
            </RaikoBaseCardContainer>
            <RaikoBaseCardContainer className={"baseMealsItemContainer"}>
                <RaikoFlexAlignStart className={css`align-items: center;
                    gap: 1rem;`}>
                    <div className={"mealsItemIconContainer"}>
                        <img src={icLunch} alt="breakfast"/>
                    </div>
                    <RaikoLabel
                        text={"ناهــار"}
                        raikoLabelType={RaikoLabelType.TITLE}
                        className={css`
                            flex-grow: 1;
                        `}
                    />
                    {
                        loading ?
                            getSkeleton() :
                            <RaikoLabel
                                text={convertCurrencyFormatPositiveNegative(lunch)}
                                raikoLabelType={RaikoLabelType.TITLE}
                                className={css`
                                    font-size: 20px;
                                    text-align: left;`}
                            />
                    }
                </RaikoFlexAlignStart>

            </RaikoBaseCardContainer>
            <RaikoBaseCardContainer className={"baseMealsItemContainer"}>
                <RaikoFlexAlignStart className={css`align-items: center;
                    gap: 1rem;`}>
                    <div className={"mealsItemIconContainer"}>
                        <img src={icDinner} alt="breakfast"/>
                    </div>
                    <RaikoLabel
                        text={"شــام"}
                        raikoLabelType={RaikoLabelType.TITLE}
                        className={css`
                            flex-grow: 1;
                        `}
                    />
                    {
                        loading ?
                            getSkeleton() :
                            <RaikoLabel
                                text={convertCurrencyFormatPositiveNegative(dinner)}
                                raikoLabelType={RaikoLabelType.TITLE}
                                className={css`
                                    font-size: 20px;
                                    text-align: left;`}
                            />
                    }
                </RaikoFlexAlignStart>
            </RaikoBaseCardContainer>
        </RaikoGridThreeColumn>
    )

}